import type { ReviewPackTemplate } from '../review-pack';

export const WEEKLY_BUSINESS_REVIEW_TEMPLATE = {
  templateId: 'logistics-wbr-default',
  cadence: 'weekly_business_review',
  industryProfileId: 'logistics-default',
  audience: 'operating_team',
  sections: [
    {
      sectionId: 'weekly_opening',
      title: 'Opening lede and what changed',
      purpose: 'Show what changed and which operating owners need action this week.',
      required: true,
      sourceAnswerFamily: 'exec_brief_v2',
      plannerArchetype: 'review_pack',
      sourceCompositionPath: 'apps/api/src/ask-helix/ask-helix.exec-brief-v2.ts',
      requiredInputs: ['brief_live_providers'],
      freshnessRequirement: { maxAgeHours: 48, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'share_snapshot'],
    },
    {
      sectionId: 'weekly_drift_recovery',
      title: 'Drift and recovery queue',
      purpose: 'Name commitments that are drifting and recovery decisions due this week.',
      required: true,
      sourceAnswerFamily: 'drift_realization',
      plannerArchetype: 'review_pack',
      sourceCompositionPath:
        'apps/api/src/ask-helix/drift/drift-realization-intent.ts',
      requiredInputs: ['decision_console_read_model', 'drift_realization_read_model'],
      freshnessRequirement: { maxAgeHours: 48, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'adopt_into_monitoring', 'share_snapshot'],
    },
    {
      sectionId: 'weekly_variance_bridge',
      title: 'Weekly operating variance bridge',
      purpose: 'Preserve current weekly operating variance without recalculating source math.',
      required: true,
      sourceAnswerFamily: 'variance_decomposition',
      plannerArchetype: 'review_pack',
      sourceCompositionPath:
        'apps/api/src/ask-helix/variance/variance-decomposition-composition.ts',
      requiredInputs: ['current_closed_week_metric_facts', 'variance_decomposition_v1'],
      freshnessRequirement: { maxAgeHours: 48, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'share_snapshot'],
    },
    {
      sectionId: 'weekly_needs_you_docket',
      title: 'Needs-you docket',
      purpose: 'Show the decisions, owners, and review triggers that need action this week.',
      required: true,
      sourceAnswerFamily: 'decision_ledger_review_queue',
      plannerArchetype: 'review_pack',
      sourceCompositionPath: 'packages/lib/src/decision-ledger.ts',
      requiredInputs: ['decision_ledger_review_triggers'],
      freshnessRequirement: { maxAgeHours: 48, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'adopt_into_monitoring', 'share_snapshot'],
    },
    {
      sectionId: 'weekly_action_gaps',
      title: 'Gaps blocking action',
      purpose: 'Name missing bindings, stale proof, and recovery owners before the WBR closes.',
      required: true,
      sourceAnswerFamily: 'exec_brief_v2',
      plannerArchetype: 'review_pack',
      sourceCompositionPath: 'apps/api/src/ask-helix/ask-helix.exec-brief-v2.ts',
      requiredInputs: ['brief_gap_cards', 'section_gap_refs'],
      freshnessRequirement: { maxAgeHours: 48, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'share_snapshot'],
    },
  ],
  freshnessPolicy: { generatedAtRequired: true, sectionAsOfRequired: true },
  requiredPermissions: ['ask_helix:read', 'decision_agent:read'],
  sharePolicy: 'immutable_snapshot',
  decisionLedgerCadence: 'weekly',
} as const satisfies ReviewPackTemplate;
